export const UPCOMING_WEEK_STATUS = 'upcoming'
export const ACTIVE_WEEK_STATUS = 'active'
export const PASSED_PRE_RANKING_STATUS = 'passed_pre_ranking'
export const PASSED_WEEK_STATUS = 'passed'
